import { ArrowDownRight } from "lucide-react";

export default function Hero() {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100svh] pt-28 md:pt-32 pb-20 flex items-center overflow-hidden"
    >
      {/* Subtle accents */}
      <div
        aria-hidden="true"
        className="absolute -top-40 -right-40 w-[640px] h-[640px] rounded-full bg-[#D8E2DC] opacity-50 blur-3xl"
      />
      <div
        aria-hidden="true"
        className="absolute bottom-0 left-0 w-[420px] h-[420px] rounded-full bg-[#E9EFEA] opacity-60 blur-3xl"
      />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12 w-full">
        <div className="grid grid-cols-12 gap-y-10 md:gap-x-12 items-end">
          <div className="col-span-12 md:col-span-10">
            <h1
              data-testid="hero-title"
              className="mt-4 font-serif font-light tracking-tighter leading-[0.95] text-[#0A140F] text-[clamp(3rem,9vw,9rem)]"
            >
              Performance
              <br />
              <span className="italic text-[#1A402B]">With</span> Trust.
            </h1>
            <p
              data-testid="hero-subtitle"
              className="mt-8 max-w-3xl font-sans font-light text-lg md:text-2xl leading-relaxed text-[#415248]"
            >
              We help companies transform by leveraging a trusted partner ecosystem.
            </p>

            <div className="mt-12 flex flex-wrap items-center gap-4">
              <button
                type="button"
                data-testid="hero-services-cta"
                onClick={() => scrollTo("services")}
                className="inline-flex items-center gap-3 px-7 py-4 bg-[#1A402B] text-white text-sm font-medium hover:bg-[#255A3C] transition-colors"
              >
                What we do
                <ArrowDownRight size={18} strokeWidth={1.5} />
              </button>
              <button
                type="button"
                data-testid="hero-ecosystem-cta"
                onClick={() => scrollTo("partners")}
                className="inline-flex items-center gap-3 px-7 py-4 border border-[#0A140F] text-[#0A140F] text-sm font-medium hover:bg-[#0A140F] hover:text-white transition-colors"
              >
                Meet the partners
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
